/** Copy from Confluence "Goal Rush User Updated Instructions" (MBP-2775) — covers Weekly and Tournament Goal Rush. */
export interface GoalRushHowItWorksSlideRaw {
  readonly title: string;
  readonly description: string;
  readonly img: string;
}

const SLIDE_1_DESC
  = '<p class="mb-2 text-lg"><strong>How Goal Rush Works</strong></p>'
    + '<p class="mb-3"><strong>Pick your teams. Score goals. Climb the leaderboard.</strong></p>'
    + '<p class="mb-3">Goal Rush is simple: you choose 15 teams, and every goal they score adds to your total. '
    + 'There are two ways to play.</p>'
    + '<p class="mb-3"><strong>Weekly Goal Rush:</strong> your teams score across a single gameweek. '
    + 'When the final match finishes, the highest total wins.</p>'
    + '<p><strong>Tournament Goal Rush:</strong> your teams score throughout an entire tournament, '
    + 'from the opening games to the final.</p>';

const SLIDE_2_DESC
  = '<p class="mb-2 text-lg"><strong>Building Your Card</strong></p>'
    + '<p class="mb-3">Build your own 15-team card, staying within a £200m budget.</p>'
    + '<p class="mb-3">In Weekly Goal Rush, your card locks once the gameweek begins, and the race is on.</p>'
    + '<p class="mb-2">In Tournament Goal Rush, joining after the tournament has started still gets you in. '
    + 'We\'ll build your card for you, within budget, using a fixed mix of teams:</p>'
    + '<ul class="list-disc pl-5"><li>1 team from Tier 1</li><li>2 from Tier 2</li><li>3 from Tier 3</li>'
    + '<li>5 from Tier 4</li><li>4 from Tier 5</li></ul>'
    + '<p class="mt-3">Any goals your teams have already scored, plus their goal difference, are added to your total straight away.</p>';

const SLIDE_3_DESC
  = '<p class="mb-2 text-lg"><strong>Scoring &amp; Leaderboard</strong></p>'
    + '<p class="mb-2"><strong>Every goal counts.</strong></p>'
    + '<p class="mb-3">Every goal scored by one of your 15 teams adds to your total, '
    + 'excluding own goals and penalty shootouts.</p>'
    + '<p class="mb-3">In Weekly Goal Rush, your score builds across the week. In Tournament Goal Rush, '
    + 'it accumulates across the whole tournament. Either way, follow your position on the live leaderboard '
    + 'as the matches are played: highest total wins.</p>'
    + '<p class="mb-2">If scores are tied, we break them in this order:</p>'
    + '<ol class="list-decimal pl-5"><li>Goal difference</li><li>Least budget spent</li><li>Earliest entry</li></ol>';

const SLIDE_4_DESC
  = '<p class="mb-2 text-lg"><strong>Tournament Goal Rush: NUDGE</strong></p>'
    + '<p class="mb-2"><strong>Swap teams. Keep your goals.</strong></p>'
    + '<p class="mb-2">Tournament Goal Rush runs a lot longer, so your card doesn\'t have to stay the same. '
    + 'At key stages, NUDGE lets you:</p>'
    + '<ul class="list-disc pl-5"><li>Swap out a team that\'s been knocked out or isn\'t delivering</li>'
    + '<li>Keep the goals it\'s already scored</li><li>Bring in a new team to chase more</li></ul>'
    + '<p class="mt-3">You get <strong>4 NUDGEs</strong> across the tournament, so use them wisely: they can make the difference. '
    + 'Weekly Goal Rush doesn\'t use NUDGE: once your card is locked for the gameweek, it stays that way.</p>';

export const GOAL_RUSH_HOW_IT_WORKS_SLIDES_RAW: readonly GoalRushHowItWorksSlideRaw[] = [
  {
    title: 'How Goal Rush Works',
    description: SLIDE_1_DESC,
    img: '/assets/slides/howToWin/goal_rush/slide1.jpg',
  },
  {
    title: 'Building Your Card',
    description: SLIDE_2_DESC,
    img: '/assets/slides/howToWin/goal_rush/slide2.jpg',
  },
  {
    title: 'Scoring & Leaderboard',
    description: SLIDE_3_DESC,
    img: '/assets/slides/howToWin/goal_rush/slide3.jpg',
  },
  {
    title: 'Tournament Goal Rush: NUDGE',
    description: SLIDE_4_DESC,
    img: '/assets/slides/howToWin/goal_rush/slide4.jpg',
  },
];
